"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLengthPlusGirth = exports.doesItFit = exports.getMaxDims = void 0;
const ASC_SORT = (x, y) => x - y;
const getMaxDims = (containerDims, contentDims) => {
    const filteredContainerDims = containerDims.filter((dim) => dim > 0);
    const sortedDims = filteredContainerDims.sort(ASC_SORT);
    if (sortedDims.length === 2) {
        const min = Math.min(...contentDims);
        return [min, sortedDims[0] - min, sortedDims[1] - min];
    }
    else {
        return sortedDims;
    }
};
exports.getMaxDims = getMaxDims;
const doesItFit = (containerDims, contentDims) => {
    const maxDims = (0, exports.getMaxDims)(containerDims, contentDims);
    const sortedContentDims = contentDims.sort(ASC_SORT);
    return sortedContentDims[0] <= maxDims[0] && sortedContentDims[1] <= maxDims[1] && sortedContentDims[2] <= maxDims[2];
};
exports.doesItFit = doesItFit;
const calculateLengthPlusGirth = (estimatedPackage) => {
    const sortedDims = [estimatedPackage.length, estimatedPackage.width, estimatedPackage.height].sort(ASC_SORT);
    return 2 * (sortedDims[0] + sortedDims[1]) + sortedDims[2];
};
exports.calculateLengthPlusGirth = calculateLengthPlusGirth;
//# sourceMappingURL=ShippingMeasurements.js.map